export const DOMESTIC = 'domestic';
export const ABROAD = 'abroad';

export default {
  travelExpenseVariables: {
    travelStartDate: 'Seyahat Başlangıç Tarihi',
    travelStartHour: 'Seyahat Başlangıç Saati',
    travelEndDate: 'Seyahat Bitiş Tarihi',
    travelEndHour: 'Seyahat Bitiş Saati',
    domestic: 'Yurtiçi',
    abroad: 'Yurtdışı',
    provinces: 'Gidilen Şehir(ler)',
    travelReasons: 'Seyahat Sebebi',
    description: 'Açıklama',
    individualAccommodation: 'Bireysel Konaklama var mı?',
    individualAccommodationDays: 'Bireysel Konaklama kaç gün?',
    workStartDate: 'İş Başlangıç Tarihi',
    workStartHour: 'İş Başlangıç Saati',
    region: 'Kıta',
    country: 'Ülke',
    passportNo: 'Pasaport No',
    roadFriends: 'Seyahat Ettiğiniz Kişiler',
    visa: 'Vize Durumu'
  }

};



// WEBPACK FOOTER //
// ./src/constants/variables.js